import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IonModal, NavController } from '@ionic/angular';
import { DBS } from 'src/app/classes/database-manager.class';
import { LocalDb } from 'src/app/classes/local-db.class';
import { WeekClass } from 'src/app/classes/week.class';
import { Week } from 'src/app/interfaces/week.interface';
import { Workout } from 'src/app/interfaces/workout.interface';
import { DataService } from 'src/app/services/data.service';
import Swal from 'sweetalert2';

@Component({
  templateUrl: './workouts.page.html',
  styleUrls: ['./workouts.page.css']
})
export class WorkoutsPage {

  week_id: number = null
  day: number = null

  currentWeek: Week = new WeekClass()
  week: Workout[] = []
  warmup: Workout[] = []
  coolDown: Workout[] = []

  weeksDb = new LocalDb(DBS.Weeks)
  workoutsDb = new LocalDb(DBS.Workouts)
  finishedWorkoutsDb = new LocalDb(DBS.FinishedWorkouts)

  warmupIsFinished: boolean = false
  mainIsFinished: boolean = false

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dataService: DataService,
    private navCtrl: NavController
  ) {
    this.week_id = Number(this.route.snapshot.params.week_id)
    this.extractStateParams()
  }

  ionViewDidEnter() {
    this.getData(this.week_id)
  }

  extractStateParams() {
    const state = this.router.getCurrentNavigation().extras.state
    if (!state) this.navigateBackToWeeks()
    this.day = state.day
  }

  navigateBackToWeeks() {
    this.navCtrl.navigateBack(`days/${this.week_id}`)
  }

  async getData(week_id: number) {

    const currentWeek = await this.weeksDb.find(this.week_id)
    const warmup = await this.getWarmupExercises()
    const coolDown = await this.getCoolDownExercises()
    const week = await this.dataService.getWeekExercises(week_id)
    const finishedWorkouts = await this.getFinishedExercises(week_id, this.day)

    this.currentWeek = <WeekClass><unknown>currentWeek
    this.warmup = this.addFinishedWorkouts(warmup, finishedWorkouts, 'warmup')
    this.week = this.addFinishedWorkouts(week, finishedWorkouts, 'main')
    this.coolDown = this.addFinishedWorkouts(coolDown, finishedWorkouts)

  }

  async getWarmupExercises() {
    return this.workoutsDb.query({
      field: 'week_id',
      op: '$eq',
      value: 1,
      sort_by: 'order'
    });
  }

  async getCoolDownExercises() {
    return this.workoutsDb.query({
      field: 'week_id',
      op: '$eq',
      value: 10,
      sort_by: 'order'
    });
  }

  async getWeekExercises(week_id: number) {
    return this.workoutsDb.query({
      field: 'week_id',
      op: '$eq',
      value: week_id,
      sort_by: 'order'
    });
  }

  async getFinishedExercises(week_id: number, day: number) {
    const finished = await this.finishedWorkoutsDb.query({
      field: 'week_id',
      op: '$eq',
      value: week_id,
      sort_by: 'workout_id'
    });
    return finished.filter(workout => workout.day == day)
  }

  addFinishedWorkouts(workouts: Workout[], finished: any[], trainingPart: string = '') {
    workouts.forEach(workout => {
      workout.when_finalized = (workout.when_finalized || [])
      finished.forEach(item => {
        const sameWeek = this.week_id === item.week_id
        const sameWorkout = workout.id === item.workout_id
        const sameDay = this.day === item.day
        if (sameWeek && sameWorkout && sameDay) {
          workout.when_finalized.push(item)
        }
      })
      workout.done = workout.repetitions <= workout.when_finalized.length
    })

    switch (trainingPart) {
      case 'warmup':
        this.warmupIsFinished = !workouts.map(w => w.done).includes(false);
        break;
      case 'main':
        this.mainIsFinished = !workouts.map(w => w.done).includes(false);
        break;
    }

    return workouts
  }

  onItemClick(workout: Workout) {
    if (workout.when_finalized.length >= workout.repetitions) {
      Swal.fire({
        heightAuto: false,
        title: 'Parabéns!',
        text: "Você já concluiu este exercício nesta semana",
        icon: 'success',
      })
      return
    }

    this.router.navigateByUrl(`workouts/${this.week_id}/${workout.id}`, {
      state: { day: this.day }
    })
  }



  @ViewChild(IonModal) modal: IonModal;
  effortPerception: number = 0;

  cancel() {
    this.modal.dismiss(null, 'cancel');
  }

  confirm() {
    this.modal.dismiss({
      effortPerception: this.effortPerception
    }, 'confirm');
  }

  onWillDismiss(event: Event) {
    const ev = event as any;
    if (ev.detail.role === 'confirm') {
      // this.message = `Hello, ${ev.detail.data}!`;
      // Salvar percepção de esforço
    }
  }

  onDidDismiss(event: Event) {
    const ev = event as any;
    // this.navCtrl.navigateBack(`/workouts/${this.weekId}`)
  }

}
